import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AppStore } from '../../store'
import { CompanyState } from '../../store/company/types'
import { SITE_ID } from '../../constants'

/**
 * El cliente debe tener como dato obligatorio:
 * - condición iva (finType)
 * -
 */

export const useCanCLientBuying = () => {
  const { companyData, loading } = useSelector<AppStore, CompanyState>(({ companyStore }) => companyStore)

  const enabledEcommerce = useMemo(() => {
    const siteWithoutEcommerce = 'BMVE'
    return SITE_ID !== siteWithoutEcommerce
  }, [])

  const hasCondicionIVA = useMemo(() => {
    let finType: boolean | null = null
    if (!loading) {
      finType = Boolean(companyData?.condicionIVA)
    }
    return finType
  }, [companyData]) // finType en ss

  return {
    enabledEcommerce,
    hasCondicionIVA,
  }
}
